import { render, staticRenderFns } from "./Kisfooter.vue?vue&type=template&id=2b618940&scoped=true&"
import script from "./Kisfooter.vue?vue&type=script&lang=js&"
export * from "./Kisfooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b618940",
  null
  
)

export default component.exports